import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers, deleteUser } from '../../../store/actions/usersActions';
import { fetchDashboards, deleteDashboard } from "../../../store/actions/dashsActions";
import { fetchGroups, deleteGroup } from '../../../store/actions/groupsActions';
import TitlePage from '../../../components/general/TitlePage/TitlePage';
import TopicManager from '../../../components/intern/TopicManager/TopicManager';
import SearchAndFilter from '../../../components/intern/SearchAndFilter/SearchAndFilter';

const GereciarPage = () => {
  const dispatch = useDispatch();

  const { users, loadingUsers, errorUsers } = useSelector((state) => state.users);
  const { groups, loadingGroups, errorGroups } = useSelector((state) => state.groups);
  const { dashs, loadingDashs, errorDashs } = useSelector((state) => state.dashs);

  const [changeType, setChangeType] = useState("gerenciarUsuarios");
  const [searchTerm, setSearchTerm] = useState('');

  // Deletar item com base no tipo
  const handleDelete = (id, type) => {
    if (type === 'user') dispatch(deleteUser(id));
    if (type === 'group') dispatch(deleteGroup(id));
    if (type === 'dashboard') dispatch(deleteDashboard(id));
  };

  const handleChangeType = (type) => {
    setChangeType(type);
    setSearchTerm('');
  };

  // Buscar dados iniciais
  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchDashboards());
    dispatch(fetchGroups());
  }, [dispatch]);

  // Exibir carregamento
  if (loadingUsers || loadingDashs || loadingGroups) {
    return <p>Carregando sistema... Por favor, aguarde.</p>;
  }

  // Exibir erros
  if (errorUsers || errorDashs || errorGroups) {
    const errorMsg = errorUsers || errorDashs || errorGroups;
    return <p>Erro: {errorMsg}</p>;
  }

  // Função genérica para filtrar listas
  const filterAll = (items, searchTerm) => {
    if (!searchTerm) return items;
    const term = searchTerm.trim().toLowerCase();
    return items.filter(item =>
      Object.values(item).some(value =>
        value && value.toString().toLowerCase().includes(term)
      )
    );
  };

  // Filtrar dados por aba
  const filteredUsers = filterAll(users, searchTerm).filter(user => user.approved);
  const filteredGroups = filterAll(groups, searchTerm);
  const filteredDashs = filterAll(dashs, searchTerm);

  return (
    <section className="container-extern content-with-sidebar">
      <TitlePage
        title="Gerenciar Dados"
        subtitle="Administre usuários, grupos e dashboards de forma centralizada, garantindo eficiência e segurança operacional."
      />

      <Helmet>
        <title>Manage Data</title>
      </Helmet>

      <SearchAndFilter
        searchTerm={searchTerm}
        onSearch={setSearchTerm}
      />

      <TopicManager
        users={changeType === "gerenciarUsuarios" ? filteredUsers : []}
        groups={changeType === "gerenciarGrupos" ? filteredGroups : []}
        dashs={changeType === "gerenciarDashboard" ? filteredDashs : []}
        onDelete={handleDelete}
        handleChangeType={handleChangeType}
        changeType={changeType}
      />
    </section>
  );
};

export default GereciarPage;
